import React, { useEffect, useState } from "react"
import { Drawer, Box, IconButton, Typography, FormGroup, FormControlLabel, Checkbox, Snackbar, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { CloseSquare, ArrowCircleRight } from 'iconsax-react';
import styles from '../my-data.module.scss';

const AddInfoMenu = ({show, setShow, window, uiStore, setNewCategories, feedback, setAddedNew,fetchData}) => {

    const container = window !== undefined ? () => window().document.body : undefined;
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [showSnackbar, setShowSnackbar] = useState(false);

    const submit = async () => {
        setLoading(true);
        await uiStore.addUserCategories(selectedCategories);
        setNewCategories(selectedCategories);
        setAddedNew(selectedCategories);
        setShow(false);
        setLoading(false);
        setShowSnackbar(true);
        if (feedback)
            feedback();
    }

    const add_category = (e) => {
        const { checked, value } = e.target;
        if (checked) {
            setSelectedCategories([...selectedCategories, value]);
        } else {
            setSelectedCategories(selectedCategories.filter(i => i !== value));
        }
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setShowSnackbar(false);
    };

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            const data = await uiStore.getGeneralUserCategories();
            setCategories(data.filter(i => !uiStore.categories?.find(k => i.categoryName === k.name)));
            setLoading(false);
        }

        if (show) {
            
            fetchData();
            setSelectedCategories([]);
        }

    }, [show, uiStore])

    return (
        <>
            <Snackbar open={showSnackbar} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    Categories Have been added
                </Alert>
            </Snackbar>

            <Drawer
                container={container}
                variant="temporary"
                open={show}
                onClose={() => setShow(false)}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: { xs: 'block', sm: 'block' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', maxWidth: '450px', width: '90%' },
                }}
            >
                <Box className={styles.mobileMenuHeader}>
                    <Box sx={{ mt: 2 }}>
                        <Typography variant='h5' fontWeight='700'>Select Categories</Typography>
                        <Typography color='#888888'>Select the data category you're adding</Typography>
                    </Box>
                    <IconButton sx={{ ml: 2, mr: 1 }} onClick={() => setShow(false)}>
                        <CloseSquare
                            size="36"
                            color='#242333'
                            variant='Bold'
                        />
                    </IconButton>
                </Box>

                <Box>
                    {categories.length === 0 && !loading ?
                        <Box className={styles.mobileMenuHeader}>
                            All the categories have been added.
                        </Box>
                        :
                        <FormGroup sx={{ m: 2, display: 'flex', flexDirection: 'row' }}>
                            {categories.map(item =>
                                <FormControlLabel
                                    className={styles.dataDialougeCheckBox}
                                    key={item._id}
                                    control={
                                        <Checkbox checked={selectedCategories.includes(item.categoryName)} />
                                    }
                                    label={<Typography fontSize='14px' fontWeight={500}>{item.categoryName}</Typography>}
                                    value={item.categoryName}
                                    onChange={add_category}
                                />
                            )}
                        </FormGroup>
                    }
                </Box>

                <Box sx={{ mt: 3 }} className={styles.dataDialougeActions}>
                    <LoadingButton
                        loading={!!loading}
                        onClick={submit}
                        disabled={selectedCategories.length === 0}
                        variant="contained"
                        color="primary"
                        endIcon={<ArrowCircleRight
                            size="24"
                            variant="Bulk"
                        />}
                    >
                        Select
                    </LoadingButton>
                </Box>
            </Drawer>
        </>
    );
}

export default AddInfoMenu;